<section class="section-product-hero" *ngIf="heroData">
  <div class="section-container">
    <div class="product-hero-content-box justfy-item-e">
      <div>
        <span class="product-hero-subheading mar-b-16" *ngIf="heroData.tag">{{
          heroData.tag
        }}</span>
        <h1 class="product-hero-header">
          {{ heroData?.header }}
        </h1>
        <div
          class="landing-hero-content mar-t-24 currency-hero-desc"
          [innerHtml]="heroData?.paragraph | toHtml"
        ></div>
        <div class="landing-btn mar-t-48 align-c">
          <a
            *ngIf="heroData?.button1?.text"
            href="{{ heroData?.button1?.url | urlParams:queryParams}}"
            target="{{ heroData?.button1?.target }}"
            class="btn btn-full"
            >{{ heroData?.button1?.text }}</a
          >
          <!-- <app-common-talktosales-button [text]="heroData?.button2?.text"></app-common-talktosales-button> -->
        </div>
      </div>
      <div class="responsive-align-items width-480 align-self-center">
        <div class="c_converter">
          <div class="cur_cal">
            <div class="row align-items-start cs_con_row flex-col">
              <div class="col first-input">
                <div class="input_one input_set">
                  <div class="select-wrapper">
                    <p class="text-sm">You pay</p>
                    <country-list
                      [selectedCountry]="selectedCountryCode1"
                      [countryList]="currencies"
                      [align]="'left'"
                      (changedCountryCode)="changeSelectedCountryCode1($event)"
                    ></country-list>
                  </div>
                  <input
                    type="text"
                    #inAmount
                    placeholder="Enter Amount"
                    (input)="collectValue($event)"
                  />
                </div>
              </div>
              <div class="col f-0 absolute-btn">
                <button
                  class="toggle_cont btn-null no-width"
                  (click)="invertCurrency()"
                >
                  <span class="svg-holder">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M5.48683 1.66668C5.31578 1.66668 5.15329 1.73505 5.03355 1.85471L1.85203 5.0342C1.60401 5.28206 1.60401 5.69232 1.85203 5.94018C2.10005 6.18804 2.51057 6.18804 2.75859 5.94018L4.85395 3.84616L4.85395 17.6923C4.85395 18.0427 5.14473 18.3333 5.49539 18.3333C5.84604 18.3333 6.12827 18.0427 6.12827 17.6923L6.12827 3.85471L8.21507 5.94018C8.46309 6.18804 8.87361 6.18804 9.12163 5.94018C9.24992 5.81197 9.30979 5.64958 9.30979 5.48719C9.30979 5.32479 9.24992 5.1624 9.12163 5.0342L5.94867 1.86326C5.8888 1.80343 5.81183 1.75215 5.7263 1.71796C5.71775 1.71796 5.7092 1.71796 5.70065 1.70941C5.63223 1.68377 5.56381 1.66668 5.48683 1.66668Z"
                        fill="#CACED1"
                      />
                      <path
                        d="M13.8591 2.3077L13.8591 16.1453L11.7723 14.0598C11.5242 13.812 11.1137 13.812 10.8657 14.0598C10.6177 14.3077 10.6177 14.718 10.8657 14.9658L14.0387 18.1368C14.0985 18.1966 14.1755 18.2479 14.261 18.2821C14.2696 18.2821 14.2781 18.2821 14.2867 18.2906C14.3551 18.3162 14.4321 18.3333 14.5091 18.3333C14.6801 18.3333 14.8426 18.265 14.9623 18.1453L18.1439 14.9658C18.2721 14.8376 18.332 14.6752 18.332 14.5128C18.332 14.3504 18.2721 14.188 18.1439 14.0598C17.8958 13.812 17.4853 13.812 17.2373 14.0598L15.1419 16.1539L15.1419 2.3077C15.1419 1.95727 14.8512 1.66668 14.5005 1.66668C14.1499 1.66668 13.8591 1.95727 13.8591 2.3077Z"
                        fill="#CACED1"
                      />
                    </svg>
                  </span>
                </button>
              </div>
              <div class="col">
                <div class="input_one input_set">
                  <div class="select-wrapper">
                    <p class="text-sm">Beneficiary receive</p>
                    <country-list
                      [selectedCountry]="selectedCountryCode2"
                      [countryList]="currencies"
                      [align]="'left'"
                      (changedCountryCode)="changeSelectedCountryCode2($event)"
                    ></country-list>
                  </div>
                  <input type="text" [(ngModel)]="outAmount" />
                </div>
              </div>
              <div class="col f-0">
                <button class="btn btn-full wid-full" (click)="sendNow()">
                  Send now
                </button>
              </div>
            </div>
            <div class="bottom-text-wrapper">
              <div class="rates-wapper">
                <p
                  class="d-inline-block mb-0 text-sm responsive-text-wrap"
                  *ngIf="gbpChange && gbpChange?.reversedRate < 100"
                >
                  1 {{ currencyFrom }} =
                  <strong
                    >{{ gbpChange?.rateAfterSpread | number: '1.2-4' }}
                    {{ currencyTo }}</strong
                  >
                </p>

                <p
                  class="d-inline-block mb-0 text-sm responsive-text-wrap"
                  *ngIf="gbpChange && gbpChange?.reversedRate > 100"
                >
                  1 {{ currencyTo }} =
                  <strong
                    >{{ 1 / gbpChange?.rateAfterSpread | number: '1.4' }}
                    {{ currencyFrom }}
                  </strong>
                </p>
                <p class="text-sm responsive-text-wrap text-gray-700">
                  We use midmarket rates
                  <span
                    tooltip="The mid-market exchange rate is typically used by banks and international brokers when transferring money between each other."
                    flow="up"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <path
                        d="M6 1C3.245 1 1 3.245 1 6C1 8.755 3.245 11 6 11C8.755 11 11 8.755 11 6C11 3.245 8.755 1 6 1ZM5.625 4C5.625 3.795 5.795 3.625 6 3.625C6.205 3.625 6.375 3.795 6.375 4V6.5C6.375 6.705 6.205 6.875 6 6.875C5.795 6.875 5.625 6.705 5.625 6.5V4ZM6.46 8.19C6.435 8.255 6.4 8.305 6.355 8.355C6.305 8.4 6.25 8.435 6.19 8.46C6.13 8.485 6.065 8.5 6 8.5C5.935 8.5 5.87 8.485 5.81 8.46C5.75 8.435 5.695 8.4 5.645 8.355C5.6 8.305 5.565 8.255 5.54 8.19C5.515 8.13 5.5 8.065 5.5 8C5.5 7.935 5.515 7.87 5.54 7.81C5.565 7.75 5.6 7.695 5.645 7.645C5.695 7.6 5.75 7.565 5.81 7.54C5.93 7.49 6.07 7.49 6.19 7.54C6.25 7.565 6.305 7.6 6.355 7.645C6.4 7.695 6.435 7.75 6.46 7.81C6.485 7.87 6.5 7.935 6.5 8C6.5 8.065 6.485 8.13 6.46 8.19Z"
                        fill="#359EB4"
                      />
                    </svg>
                  </span>
                </p>
              </div>
              <div>
                <p class="last-updated-text">
                  Last updated {{ today | date: 'long' }}
                </p>
              </div>
            </div>
            <div class="row margin-top-1">
              <span class="text-danger text-sm">{{ noValueErrMsg }}</span>
            </div>
          </div>
        </div>
        <div class="cur_cal text-center" *ngIf="noData">
          <h3>Data Not Available</h3>
        </div>
      </div>
    </div>
  </div>
</section>
